import { render, staticRenderFns } from "./WelfareCooperation.vue?vue&type=template&id=aa7a6d26&"
import script from "./WelfareCooperation.vue?vue&type=script&lang=js&"
export * from "./WelfareCooperation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports